/**
 * 
 * @author Tim
 * @date 2024-08-27
 */

import { get, post, put, del } from '@/lib/request.js';

class api {
	async checking(params) {
	  return await get('base/app/inlet/checking', params);
	}
	
	// 支付宝登录接口
	async loginAlipay(data) {
	  return await post('apis/client/auth/login-alipay', data);
	}
	
	// 微信公众号登录接口
	async loginWechatMP(data) {
	  return await post('apis/client/auth/login-wechat-mp', data);
	}
	
	// 绑定微信公众号OpenID
	async bindWechatMP(data) {
	  return await post('apis/client/auth/bind-wechat-mp', data);
	}
	
	// 获取文章列表
	async getArticles(data) {
	  return await get('apis/client/articles', data);
	}
	
	// 获取文章详情
	async getArticleDetail(data) {
	  return await get('apis/client/articles/detail', data);
	}
	
	// 获取文章分类列表
	async getArticleCategories(data) {
	  return await get('apis/client/article/categories', data);
	}
	
	// 获取横幅列表 (临时占位，根据实际API调整)
	async getBannerApp(data) {
	  return await get('apis/client/banners', data);
	}
	
	// ========== 订单和支付相关接口 ==========
	
	// 创建API订单
	async createAPIOrder(data) {
		return await post('apis/client/orders/api', data);
	}
	
	// 获取订单执行状态
	async getOrderExecuteStatus(params) {
		return await get('apis/client/orders/execute-status', params);
	}
	
	// 获取订单详情
	async getOrderDetail(data) {
	  return await get('apis/client/orders/detail', data);
	}
	
	// 获取支付方式列表
	async getPaymentMethods(data) {
	  return await get('apis/client/payment/methods', data);
	}
	
	// 支付宝小程序支付
	async payAlipayMini(data) {
	  return await post('apis/client/payment/alipay/mini', data);
	}
	
	// 支付宝H5支付
	async payAlipayH5(data) {
	  return await post('apis/client/payment/alipay/h5', data);
	}
	
	// 支付宝PC支付
	async payAlipayPC(data) {
	  return await post('apis/client/payment/alipay/pc', data);
	}
	
	// 微信小程序支付
	async payWechatMini(data) {
	  return await post('apis/client/payment/wechat/jsapi', data);
	}
	
	// 微信公众号支付 (H5)
	async payWechatJSAPI(data) {
	  return await post('apis/client/payment/wechat/jsapi', data);
	}
	
	// 微信扫码支付 (Native)
	async payWechatNative(data) {
	  return await post('apis/client/payment/wechat/native', data);
	}
	
	// 微信H5支付
	async payWechatH5(data) {
	  return await post('apis/client/payment/wechat/h5', data);
	}
	
	// 余额支付
	async payBalance(data) {
	  return await post('apis/client/payment/balance', data);
	}
	
	// 积分支付
	async payPoints(data) {
	  return await post('apis/client/payment/points', data);
	}
	
	// 查询支付状态
	async getPaymentStatus(data) {
	  return await get('apis/client/payment/status', data);
	}
	
	// 查询订单状态
	async queryOrder(data) {
	  return await get('apis/client/payment/query', data);
	}
	
	// 获取用户信息
	async getUserInfo() {
	  return await get('apis/client/member/info');
	}
	
	// 获取评论列表
	async getComments(params) {
		return await get('apis/client/article/comments', params);
	}
	
	// 提交评论
	async addComment(params) {
		return await post('apis/client/article/comments', params);
	}
}

export default new api()